import React from 'react';
import styled from 'styled-components';

import DownRatingIcon from 'components/icons/DownRatingIcon';
import UpRatingIcon from 'components/icons/UpRatingIcon';
import {
  Rows,
  Section,
  SectionTitle,
  Row,
  RowLabel,
} from 'modules/health/commonStyles/header';
import { formatScoreChange } from 'modules/health/helpers/formatScoreChange';

interface ChangeInScoreProps {
  thisMonth: number;
  thisQuarter: number;
  thisYear: number;
}

const ChangeInScore = ({
  thisMonth,
  thisQuarter,
  thisYear,
}: ChangeInScoreProps) => {
  const changeRows = [
    { label: 'This month', value: thisMonth },
    { label: 'This quarter', value: thisQuarter },
    { label: 'This year', value: thisYear },
  ];

  return (
    <Section>
      <SectionTitle $align="flex-end">Change in score</SectionTitle>
      <Rows>
        {changeRows.map((row) => (
          <Row key={row.label}>
            <RowLabel>{row.label}</RowLabel>
            <ArrowAndValue>
              <span>
                {row.value !== 0 &&
                  (row.value > 0 ? (
                    <UpRatingIcon color="#fff" />
                  ) : (
                    <DownRatingIcon color="#fff" />
                  ))}
              </span>
              <ChangeValue>{formatScoreChange(row.value)}</ChangeValue>
            </ArrowAndValue>
          </Row>
        ))}
      </Rows>
    </Section>
  );
};

const ArrowAndValue = styled.div`
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ChangeValue = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.white};
`;

export default ChangeInScore;
